const prefix = <const T extends string>(id: T) => `CardPayments.${id}` as const

export * as Strings from './strings'

export const Ids = {
  Press: {
    PointsBalance: prefix('Press.PointsBalance'),
    LoadingPointsBalance: prefix('Press.LoadingPointsBalance'),
    ZeroPointsBalance: prefix('Press.ZeroPointsBalance'),
    ScheduledPayment: prefix('Press.ScheduledPayment'),
    ScheduleOnetimePay: prefix('Press.ScheduleOnetimePay'),
    ScheduleAutoPay: prefix('Press.ScheduleAutoPay'),
    Continue: prefix('Press.Continue'),
    SetAutoPay: prefix('Press.SetAutoPay'),
    Pay: prefix('Press.Pay'),
    SubmitPayment: prefix('Press.SubmitPayment'),
    OtherAmount: prefix('Press.OtherAmount'),
    Today: prefix('Press.Today'),
    CancelOnetimePay: prefix('Press.CancelOnetimePay'),
    CancelAutoPay: prefix('Press.CancelAutoPay'),
    ViewAutoAgreement: prefix('Press.ViewAutoAgreement'),
  },
  View: {
    AutoPayAgreement: prefix('View.AutopayAgreement'),
  },
  Text: {
    ScheduledPaymentsHeader: prefix('Text.ScheduledPaymentsHeader'),
    MultipleOneTimePaymentsScheduled: prefix('Text.MultipleOneTimePaymentsScheduled'),
    SingleOneTimePaymentScheduled: prefix('Text.SingleOneTimePaymentScheduled'),
  },
  Input: {
    SelectAutoPayDayOfTheMonth: prefix('Input.SelectAutoPayDayOfTheMonth'),
  },
} as const
